export const OPEN_ASSIGN_TO_USER_MODAL = 'OPEN_ASSIGN_TO_USER_MODAL';
export const CLOSE_ASSIGN_TO_USER_MODAL = 'CLOSE_ASSIGN_TO_USER_MODAL';
export const CLOSE_ASSIGN_TO_USER_ERROR = 'CLOSE_ASSIGN_TO_USER_ERROR';

function openAssignToUserModal(formsList) {
  return {
    type: OPEN_ASSIGN_TO_USER_MODAL,
    isAssignToUserModalShown: true,
    formsList
  };
}

function closeAssignToUserModal() {
  return {
    type: CLOSE_ASSIGN_TO_USER_MODAL,
    isAssignToUserModalShown: false
  };
}

function closeAssignToUserError() {
  return {
    type: CLOSE_ASSIGN_TO_USER_ERROR,
    isAssignToUserModalShown: true
  };
}

export function showAssignToUserModal(formsList) {
  return (dispatch) => {
    dispatch(openAssignToUserModal(formsList));
  };
}

export function hideAssignToUserModal() {
  return (dispatch) => {
    dispatch(closeAssignToUserModal());
  };
}

export function hideAssignToUserError() {
  return (dispatch) => {
    dispatch(closeAssignToUserError());
  };
}
